// extracted by mini-css-extract-plugin
export default {"root":"Chart_root__hkTbz","header":"Chart_header__D9gHs","title":"Chart_title__NLCRF","value":"Chart_value__89iPp"};